import React from "react";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function CheckEmail() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: 4, px: 2 }}>
      <Card sx={{ maxWidth: 480, width: "100%" }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Check your email
          </Typography>
          <Typography color="text.secondary" paragraph>
            We sent a verification link. Open it to confirm your account, then you
            can create your farm or sign in.
          </Typography>
          <Button component={RouterLink} to="/login" variant="contained">
            Back to sign in
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
